module.exports = __webpack_public_path__ + "static/media/suggestions-top-bg.34b07976.png";